import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LeadService } from 'src/app/private/services/lead.service';
import { TicketService } from 'src/app/private/services/tickets.service';
import { UsersService } from 'src/app/private/services/users.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-ticket-report-details',
  imports: [SharedModule],
  templateUrl: './ticket-report-details.component.html',
  styleUrl: './ticket-report-details.component.scss'
})
export class TicketReportDetailsComponent {
  title = '';
  slug = '';
  dataSource: any[] = [];
  totalRows = 0;
  rows = 10;

  // Loading states
  initialLoad = true;
  isDataLoading = false;
  filterLoading = false;

  // Filter sidebar
  isOpen = false;

  // Filters


  ticketStatusList: any[] = [
    { label: "New", value: "New" },
    { label: "Open", value: "Open" },
    { label: "In Progress", value: "In Progress" },
    { label: "On Hold", value: "On Hold" },
    { label: "Esclated", value: "Esclated" },
    { label: "Resolved", value: "Resolved" },
    { label: "Closed", value: "Closed" },
    { label: "Canceled", value: "Canceled" },
    { label: "Draft", value: "Draft" },
    { label: "Reopened", value: "Reopened" },
    { label: "Deleted", value: "Deleted" }
  ]

  priorityList: any[] = [
    { label: "Low", value: "Low" },
    { label: "Medium", value: "Medium" },
    { label: "High", value: "High" },
  ];

  leadSourceList: any[] = [
    { label: 'Channel Partner', value: 'Channel Partner' },
    { label: 'Conference', value: 'Conference' },
    { label: 'Field Visit', value: 'Field Visit' },
    { label: 'Google', value: 'Google' },
    { label: 'Instagram', value: 'Instagram' },
    { label: 'Lead Gen Tools', value: 'Lead Gen Tools' },
    { label: 'Live Session', value: 'Live Session' },
    { label: 'Personal', value: 'Personal' },
    { label: 'Referral', value: 'Referral' },
    { label: 'LinkedIn', value: 'LinkedIn' },
    { label: 'Website', value: 'Website' },
    { label: 'WhatsApp', value: 'WhatsApp' },
    { label: 'Tina', value: 'Tina' },
    { label: 'Intern', value: 'Intern' },
    { label: 'Other', value: 'Other' }
  ];

  selectedTicketSourceFilter: any[] = [
    { label: 'Tina', value: 'Tina' }
  ];

  selectedTodayFilter: string = 'today';

  leadOwnerList: any[] = [];

  selectedTicketStatusFilter: any[] = [
    { label: "New", value: "New" }
  ];

  selectedTicketPriorityFilter: any[] = [
    { label: "Low", value: "Low" }
  ];

  isAdmin: boolean = true;

  showTicketDescriptionDialog: boolean = false;



  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private ticketService: TicketService,
    private localStorage: LocalStorageService,
    private userService: UsersService
  ) {
    this.slug = this.route.snapshot.paramMap.get('slug') || '';
    this.selectedTodayFilter = 'today'
  }

  selectedLeadOwnerFilter: any[] = [{
    user_id: this.localStorage.getUserId(),
    name: this.localStorage.getUserFullName()
  }];

  loadData(event: any) {
    const page = (event.first / event.rows) * event.rows;
    const size = event.rows;
    switch (this.slug) {
      case 'tickets-by-status':
        this.title = "Tickets by Status";
        this.getTicketsByStatus(page, size);
        break;
      case 'tickets-by-priority':
        this.title = "Tickets by Priority";
        this.getTicketsByPriority(page, size);
        break;
      case 'tickets-by-source':
        this.title = "Tickets by Source";
        this.getTicketsBySource(page, size);
        break;
      case 'tickets-assigned-to':
        this.title = "Tickets by Assigned To";
        this.getAllLeadOwners();
        this.getTicketsByUser(page, size);
        break;
      default:
        this.title = "Report Details";
    }
  }


  getAllLeadOwners() {
    let param = {
      organization_id: this.localStorage.getOrganizationId(),
    };
    this.userService.findAllUsers(param).subscribe({
      next: (res: any) => {
        this.leadOwnerList = res || [];
        this.leadOwnerList = this.leadOwnerList.map((user: any) => {
          return {
            name: user.fname + " " + user.lname,
            user_id: user?.user_id
          };
        });
      },
      error: (e: any) => {
        console.error(e);
      },
    });
  }




  openBulkFilter(): void {
    this.isOpen = true;
  }

  applyBulkFilter(): void {
    this.filterLoading = true;
    this.loadData({
      first: 0,
      rows: this.rows
    });
  }

  showDescription(element: any, ticketDescription: any): void {
    ticketDescription.show = true;
    ticketDescription.description = element.ticket_desc || 'No description available';
  }


  getTicketsByStatus(currentPage: number, rows: number): void {
    this.isDataLoading = true;

    const param: any = {
      "where": {
        "organization_id": this.localStorage.getOrganizationId(),
        "ticket_status": this.selectedTicketStatusFilter.map(status => status.value)
      },

      page: currentPage,
      limit: rows,
      "order": {
        "col": "\"ticket\".\"updatedAt\"",
        "dir": "DESC"
      }
    };

    if (!this.isAdmin) {
      param.where.user_id = this.localStorage.getUserId();
    }

    this.ticketService.getAllTickets(param).subscribe({
      next: (res: any) => {
        this.dataSource = res.rows;
        this.totalRows = res.count;
        this.isDataLoading = false;
        this.initialLoad = false;
        this.filterLoading = false;
      },
      error: () => {
        this.isDataLoading = false;
        this.initialLoad = false;
        this.filterLoading = false;
      }
    });
  }

  getTicketsByPriority(currentPage: number, rows: number): void {
    this.isDataLoading = true;

    const param: any = {
      "where": {
        "organization_id": this.localStorage.getOrganizationId(),
        "priority": this.selectedTicketPriorityFilter.map(priority => priority.value)
      },

      page: currentPage,
      limit: rows,
      "order": {
        "col": "\"ticket\".\"updatedAt\"",
        "dir": "DESC"
      }
    };

    if (!this.isAdmin) {
      param.where.user_id = this.localStorage.getUserId();
    }

    this.ticketService.getAllTickets(param).subscribe({
      next: (res: any) => {
        this.dataSource = res.rows;
        this.totalRows = res.count;
        this.isDataLoading = false;
        this.initialLoad = false;
        this.filterLoading = false;
      },
      error: () => {
        this.isDataLoading = false;
        this.initialLoad = false;
        this.filterLoading = false;
      }
    });
  }


  getTicketsBySource(currentPage: number, rows: number): void {
    this.isDataLoading = true;

    const param: any = {
      "where": {
        "organization_id": this.localStorage.getOrganizationId(),
        "source": this.selectedTicketSourceFilter.map(source => source.value)
      },

      page: currentPage,
      limit: rows,
      "order": {
        "col": "\"ticket\".\"updatedAt\"",
        "dir": "DESC"
      }
    };

    if (!this.isAdmin) {
      param.where.user_id = this.localStorage.getUserId();
    }

    this.ticketService.getAllTickets(param).subscribe({
      next: (res: any) => {
        this.dataSource = res.rows;
        this.totalRows = res.count;
        this.isDataLoading = false;
        this.initialLoad = false;
        this.filterLoading = false;
      },
      error: () => {
        this.isDataLoading = false;
        this.initialLoad = false;
        this.filterLoading = false;
      }
    });
  }

  getTicketsByUser(currentPage: number, rows: number): void {
    this.isDataLoading = true;

    const param: any = {
      "where": {
        "organization_id": this.localStorage.getOrganizationId(),
        // "assign_to": this.localStorage.getUserId()
        "assign_to": this.selectedLeadOwnerFilter.map(owner => owner.user_id)
      },

      page: currentPage,
      limit: rows,
      "order": {
        "col": "\"ticket\".\"updatedAt\"",
        "dir": "DESC"
      }
    };

    this.ticketService.getAllTickets(param).subscribe({
      next: (res: any) => {
        this.dataSource = res.rows;
        this.totalRows = res.count;
        this.isDataLoading = false;
        this.initialLoad = false;
        this.filterLoading = false;
      },
      error: () => {
        this.isDataLoading = false;
        this.initialLoad = false;
        this.filterLoading = false;
      }
    });
  }


  // Helpers
  getOwnerName(user: any): string {
    return [user.fname, user.lname].filter(Boolean).join(' ') || 'N/A';
  }

  isSourceImage(source: string): any {
    return source && (source.endsWith('.png') || source.endsWith('.jpg') || source.endsWith('.jpeg') || source.includes('/assets/'));
  }

  getLeadSourceImg(source: string) {
    if (source == 'tina') {
      source = 'Tina'
    } else if (source == 'whatsapp') {
      source = 'WhatsApp'
    } else if (source == 'manual') {
      source = 'Manual'
    }
    return `/assets/images/${source}.png`;
  }

  getStatusColor(status: string): string {
    switch (status) {
      case 'New': return '#3498db';       // Blue
      case 'Open': return '#f39c12';      // Orange
      case 'In Progress': return '#27ae60'; // Green
      case 'On Hold': return '#8e44ad';   // Purple
      case 'Esclated': return '#e67e22';  // Dark Orange
      case 'Resolved': return '#2ecc71';  // Light Green
      case 'Closed': return '#1FAF38';    // Dark Green
      case 'Canceled': return '#e74c3c';  // Red
      case 'Draft': return '#95a5a6';     // Gray
      case 'Reopened': return '#16a085';  // Teal
      case 'Deleted': return '#c0392b';   // Dark Red
      default: return '#7f8c8d';          // Default Gray
    }
  }







  getInitials(element: any): string {
    const name = [element.first_name, element.last_name].filter(Boolean).join(' ');
    const initials = name.split(' ').map((n: string) => n.charAt(0).toUpperCase()).join('');
    return initials.length > 2 ? initials.slice(0, 2) : initials;
  }

  getName(element: any): string {
    return [element.first_name, element.last_name].filter(Boolean).join(' ') || 'N/A';
  }

  getStatusClass(element: any): string {
    const statusMap: { [key: string]: string } = {
      'New': 'bg-green-100 text-green-800 dark:bg-green-800 dark:text-green-100',
      'In Progress': 'bg-yellow-100 text-yellow-800 dark:bg-yellow-800 dark:text-yellow-100',
      'Closed': 'bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-100',
    };
    return statusMap[element.status] || 'bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-100';
  }

  getStatusDotClass(element: any): string {
    const statusDotMap: { [key: string]: string } = {
      'New': 'bg-green-500',
      'In Progress': 'bg-yellow-500',
      'Closed': 'bg-red-500',
    };
    return statusDotMap[element.status] || 'bg-gray-500';
  }



}


function observableOf(arg0: null): any {
  console.log(arg0);
  throw new Error('Function not implemented.');
}
